"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const shareExperienceCard_1 = __importDefault(require("./shareExperienceCard"));
const newBoxStyles_1 = __importDefault(require("../box/newBoxStyles"));
const surveySlice_1 = require("../../features/survey/surveySlice");
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const store_1 = require("../../store");
const ShareExperience = ({ ongoingLoanApplication, activeLoan, submittedRating, nps_survey, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const getSurvey = async () => {
        if (nps_survey) {
            await dispatch((0, surveySlice_1.getFormQuestion)({
                question_id: nps_survey.question_id,
                loan_id: nps_survey.loan_id,
            }));
        }
    };
    // check if there's a nps survey to answer
    (0, react_1.useEffect)(() => {
        getSurvey();
    }, [nps_survey]);
    let shareExperienceCard = react_1.default.createElement(react_native_1.View, null);
    if (nps_survey) {
        shareExperienceCard = (react_1.default.createElement(react_native_1.View, { style: [newBoxStyles_1.default.boxContainer, { paddingHorizontal: 15 }] },
            react_1.default.createElement(shareExperienceCard_1.default, { message: "Would you recommend Lendigo to a Friend?", submessage: "Kindly take a minute to give us your feedback by clicking the button below.", buttonTitle: "GO TO SURVEY", eventName: "go_to_NpsSurvey", action: () => navigation.navigate(screenConstants_1.SURVEY_SCREEN) })));
    }
    if ((ongoingLoanApplication || activeLoan) && !submittedRating) {
        shareExperienceCard = (react_1.default.createElement(react_native_1.View, { style: [newBoxStyles_1.default.boxContainer, { paddingHorizontal: 15 }] },
            react_1.default.createElement(shareExperienceCard_1.default, { message: "Tell us how your application experience was", buttonTitle: "LET'S GO", eventName: "go_to_ReviewApplication" })));
    }
    return shareExperienceCard;
};
exports.default = ShareExperience;
